export default __webpack_public_path__ + "assets/a21a6ae09972e9416ec2b25c12cdf54e.png";